import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getTermometroFinanceiroAnaliseDescontos(): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/termometro/financeiro/detalhes_descontos/', {});
  return data;
}

type QueryFnType = typeof getTermometroFinanceiroAnaliseDescontos;

function useTermometroFinanceiroAnaliseDescontos() {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['termometro-financeiro-analise-descontos'],
    queryFn: getTermometroFinanceiroAnaliseDescontos,
  });
}

export { getTermometroFinanceiroAnaliseDescontos, useTermometroFinanceiroAnaliseDescontos };
